import { Box, Typography, Popover, Tabs, Tab, Paper } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DatePicker, TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import React, { useState } from "react";

import { SafeArgonButton } from "0.Mine/4.Argon/ArgonComponents";

interface DueDateDialogProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSave: (date: Date | null) => void;
  currentDueDate: Date | null;
}

const DueDateDialog: React.FC<DueDateDialogProps> = ({
  anchorEl,
  open,
  onClose,
  onSave,
  currentDueDate,
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedDate, setSelectedDate] = useState<Date | null>(currentDueDate);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number): void => {
    setSelectedTab(newValue);
  };

  const mergeDateAndTime = (datePart: Date, timePart: Date): Date => {
    const merged = new Date(datePart);
    merged.setHours(timePart.getHours(), timePart.getMinutes(), timePart.getSeconds());
    return merged;
  };

  const handleDateChange = (newDate: Date | null): void => {
    if (!newDate) {
      setSelectedDate(null);
      return;
    }

    if (selectedDate) {
      // Preserve existing time
      const updated = mergeDateAndTime(newDate, selectedDate);
      setSelectedDate(updated);
    } else {
      setSelectedDate(newDate);
    }
  };

  const handleTimeChange = (newTime: Date | null): void => {
    if (!newTime) return;

    if (selectedDate) {
      const updated = mergeDateAndTime(selectedDate, newTime);
      setSelectedDate(updated);
    } else {
      setSelectedDate(newTime);
    }
  };

  const handleSave = (): void => {
    onSave(selectedDate);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
    >
      <Paper sx={{ width: 340, p: 1 }} elevation={3}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Data & Ora" />
          {/*<Tab label="Preset" />
                    <Tab label="None" />*/}
        </Tabs>

        <Box sx={{ p: 2 }}>
          {selectedTab === 0 && (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <DatePicker
                  label="Data"
                  minDate={new Date()}
                  disablePast
                  value={selectedDate}
                  onChange={handleDateChange}
                  slots={{
                    textField: TextField,
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      InputLabelProps: {
                        sx: {
                          transform: "translate(11px, 8px) scale(1)",
                          transition: "all 0.2s ease",
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -9px) scale(0.75)",
                          },
                        },
                      },
                    },
                  }}
                />
                <TimePicker
                  label="Ora"
                  value={selectedDate}
                  onChange={handleTimeChange}
                  slots={{
                    textField: TextField,
                  }}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      InputLabelProps: {
                        sx: {
                          transform: "translate(11px, 8px) scale(1)",
                          transition: "all 0.2s ease",
                          "&.MuiInputLabel-shrink": {
                            transform: "translate(14px, -9px) scale(0.75)",
                          },
                        },
                      },
                    },
                  }}
                  ampm={false}
                />
              </Box>
            </LocalizationProvider>
          )}

          {/*{selectedTab === 1 && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <SafeArgonButton
                                size="small"
                                onClick={() => {
                                    const tomorrow = new Date();
                                    tomorrow.setDate(tomorrow.getDate() + 1);
                                    setSelectedDate(tomorrow);
                                }}
                            >
                                Domani
                            </SafeArgonButton>
                            <SafeArgonButton
                                size="small"
                                onClick={() => {
                                    const nextWeek = new Date();
                                    nextWeek.setDate(nextWeek.getDate() + 7);
                                    setSelectedDate(nextWeek);
                                }}
                            >
                                Prossima Settimana
                            </SafeArgonButton>
                            <SafeArgonButton
                                size="small"
                                onClick={() => {
                                    const nextMonth = new Date();
                                    nextMonth.setMonth(nextMonth.getMonth() + 1);
                                    setSelectedDate(nextMonth);
                                }}
                            >
                                Prossimo Mese
                            </SafeArgonButton>
                        </Box>
                    )}

                    {selectedTab === 1 && (
                        <Box sx={{ p: 2, textAlign: 'center' }}>
                            <Typography variant="body2">
                                Rimuovere la data di scadenza farà sì che questa attività non abbia una scadenza.
                            </Typography>
                            <SafeArgonButton
                                color="error"
                                size="small"
                                onClick={() => {
                                    setSelectedDate(null);
                                    handleSave();
                                }}
                                sx={{ mt: 2 }}
                            >
                                Rimuovi data di scadenza
                            </SafeArgonButton>
                        </Box>
                    )}*/}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <SafeArgonButton size="small" onClick={onClose} sx={{ mr: 1 }}>
              Annulla
            </SafeArgonButton>
            <SafeArgonButton size="small" color="primary" onClick={handleSave}>
              Applica
            </SafeArgonButton>
          </Box>
        </Box>
      </Paper>
    </Popover>
  );
};

export default DueDateDialog;
